import React, { ReactElement } from 'react';

import ToolbarTool from '../../../ToolbarTool';
import Icon from '../../../../../../components/icons/Icon';
import { Sheet } from '../../../../../../mobile/structural/sheet/Sheet';
import type { UseSheetReturnType } from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import LabelsSearchBar from '../components/LabelsSearchBar';
import LabelLists from '../components/LabelLists';
import type { LabelsToolController } from '../hooks/labelsToolTypes';
import type { Label } from '../../../../../../../common/labels/labelTypes';

type MobileGenericLabelsToolProps = {
    gridSize: number;
    name: string;
    sheetProps: UseSheetReturnType;
    controller: LabelsToolController;
    handleClickEdit?: (label: Label) => void;
};

/** Shared mobile label tool shell for element-owned and task-item-owned controllers. */
const MobileGenericLabelsTool = ({
    gridSize,
    name,
    sheetProps,
    controller,
    handleClickEdit,
}: MobileGenericLabelsToolProps): ReactElement => {
    const { isOpen, openSheet } = sheetProps;
    const {
        allLabels,
        selectedLabelIds,
        hasCompletedInitialFetch,
        searchString,
        setSearchString,
        handleCreateLabel,
        handleSearchSubmit,
        handleToggleLabelSelection,
    } = controller;

    return (
        <>
            <ToolbarTool name={name} isOpen={isOpen} onClick={() => openSheet()}>
                <Icon gridSize={gridSize} name="toolbar-label" />
            </ToolbarTool>
            <Sheet className="LabelsToolbarSheet" {...sheetProps} defaultSnapPoint={0.5} snapPoints={[0.5, 0.9]}>
                <Sheet.Overlay />
                <Sheet.Panel>
                    <Sheet.Header>
                        <Sheet.Heading>{name}</Sheet.Heading>
                        <Sheet.DoneButton />
                    </Sheet.Header>
                    <LabelsSearchBar
                        value={searchString}
                        onChange={setSearchString}
                        handleSearchSubmit={handleSearchSubmit}
                        autoFocus={false}
                        className="!px-4"
                        size="lg"
                    />
                    <Sheet.Content className="px-3.5 py-1.5">
                        <LabelLists
                            handleToggleLabelSelection={handleToggleLabelSelection}
                            handleCreateLabel={handleCreateLabel}
                            selectedLabelIds={selectedLabelIds}
                            searchString={searchString}
                            allLabels={allLabels}
                            hasCompletedInitialFetch={hasCompletedInitialFetch}
                            handleClickEdit={handleClickEdit}
                            isSheet
                            size="lg"
                        />
                    </Sheet.Content>
                </Sheet.Panel>
            </Sheet>
        </>
    );
};

export default MobileGenericLabelsTool;
